import { fromJS } from 'immutable'
import {
  SUBCONTRACT_COST_GET_REQUEST,
  SUBCONTRACT_COST_GET_SUCCESS,
  SUBCONTRACT_COST_GET_FAILURE,
  SUBCONTRACT_COST_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SUBCONTRACT_COST_GET_REQUEST:
      return state
        .set('isFetching', true)
    case SUBCONTRACT_COST_GET_SUCCESS:
      return state
        .set('subcontractCostMasters', fromJS(action.payload.subcontractCostMasters))
        .set('isFetching', false)
    case SUBCONTRACT_COST_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case SUBCONTRACT_COST_GET_RESET:
      return state
        .delete('subcontractCostMasters')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/subcontract-cost/subcontract-cost-get-reducer.js